import TemplateView from "../TemplateView"
import ClassicBridge from '../next/ClassicBridge'

export const RelatedType = {
    Customer: 'Customer',
    Project: 'Project',
    Task: 'Task',
}

export default class BudgetsTab extends TemplateView {
    constructor({
        relatedType,
    }) {
        super()
        this.state = {
            relatedId: null,
            areCostBudgetsEnabled: false,
            areBillingBudgetsEnabled: false,
            typeOfWork: undefined,
        }

        this.relatedType = relatedType

        this.onAnyStatePropertyChanged([
            'relatedId',
            'areCostBudgetsEnabled',
            'areBillingBudgetsEnabled',
            'typeOfWork'
        ], () => {
            this.update()
        })
    }

    update() {
        if (this.budgets) this.budgets.remove()
        if (!this.state.relatedId) return

        this.budgets = ClassicBridge.integrateBudgetsTab(this.find('.atNextMount')[0], {
            relatedType: this.relatedType,
            relatedId: this.state.relatedId,
            areCostBudgetsEnabled: this.state.areCostBudgetsEnabled,
            areBillingBudgetsEnabled: this.state.areBillingBudgetsEnabled,
            typeOfWork: this.state.typeOfWork
                        ? {
                    ...this.state.typeOfWork,
                    title: this.state.typeOfWork.name,
                }
                        : undefined,
        })
    }

    templateHtml() {
        return "<div class='tab'>" +
               "  <div class='atNextMount'></div>" +
               "</div>"
    }
}



// WEBPACK FOOTER //
// ./web/js/panels/BudgetsTab.js